// extracted by mini-css-extract-plugin
module.exports = {"friend":"Friend_friend__1R_N9","jump":"Friend_jump__3Wr7D"};